export default __webpack_public_path__ + "static/media/project3.054cb2dd.png";